import { formatToDecimals } from 'lib/helpers/formatting';
import React from 'react';

const ExpenseItemCard = ({
	title,
	subtitle,
	graph,
	residual,
}: {
	title: string;
	subtitle: string;
	graph: React.ReactNode;
	residual: number;
}) => (
	<div
		style={{
			width: '366px',
			height: '506px',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			alignItems: 'center',
			borderColor: '#C7CFD7',
			borderRadius: '12px',
			borderWidth: '1px',
			borderStyle: 'solid',
			boxShadow: '0px 16px 40px 0px #0000000D',
			padding: '24px',
		}}
	>
		<span style={{ fontSize: '18px', fontWeight: 700 }}>{title}</span>
		<span style={{ fontSize: '18px', fontWeight: 400 }}>{subtitle}</span>
		{graph}
		<div
			style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '8px', justifyContent: 'space-between', alignItems: 'center' }}
		>
			<hr style={{ height: '1px', width: '100%', color: '#1C2743', backgroundColor: '#1C2743', opacity: 1 }} />
			<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
				<span style={{ fontSize: '18px', fontWeight: 700 }}>Spesa residua:</span>
				<span style={{ fontSize: '16px', fontWeight: 400 }}>{formatToDecimals(residual)}</span>
			</div>
		</div>
	</div>
);

export default ExpenseItemCard;
